<ng-container *ngFor="let e of controlArray.controls ; let i = index;">
    <div class="filter-tag" *ngIf="e.value===true">
        {{label}}:
        {{dataSelectLabel[i]?.text || dataSelectLabel[i]?.address3 ||  dataSelectLabel[i]}} <a (click)="onRemoveOption(i)" class="remove"
            title="Eliminar">×</a>
    </div>
</ng-container>